import { render } from "./SearchPageTitle.vue?vue&type=template&id=e2fd8fc4&scoped=true"
import script from "./SearchPageTitle.vue?vue&type=script&lang=js"
export * from "./SearchPageTitle.vue?vue&type=script&lang=js"

import "./SearchPageTitle.vue?vue&type=style&index=0&id=e2fd8fc4&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2fd8fc4"]])

export default __exports__